import OverlayLoginRegister from '@/pages/OverlayLoginRegister'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: OverlayLoginRegister,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}